import {ActionType, type ActionBubble} from "@khan/guide-types";

/**
 * A map of action types that should not send a message when the action is
 * triggered.
 */
const ACTION_TYPES_EXCLUDING_MESSAGES = {
    [ActionType.openModal]: true,
    [ActionType.copyToClipboard]: true,
    [ActionType.replaceHighlightedText]: true,
    [ActionType.newPrefilledChat]: true,
    [ActionType.navigation]: true,
};

export const shouldSendMessageForActionBubble = (
    actionBubble: ActionBubble,
) => {
    const actions = actionBubble.actions ?? [];
    return actions.every(
        ({actionType}) => !ACTION_TYPES_EXCLUDING_MESSAGES[actionType],
    );
};
